/* global __WATCH__:false */
import { triggerTracking } from 'modules/ensighten_tracking/EnsightenTracking';

export default class YoutubePlayer {
  constructor({ id, tracking_name = 'nvs', domElementId, autoplay = false }) {
    this.domElementId = domElementId;
    this.id = id;
    this.tracking_name = tracking_name;
    this.autoplay = autoplay ? 1 : 0;
    this.player = null;
    this.init(this.autoplay);
  }

  init(autoplay) {
    // add youtube api to dom - async
    const yt = '//www.youtube-nocookie.com'; // '//www.youtube-nocookie.com'; // '//www.youtube.com';
    const tag = document.createElement('script');
    tag.src = `//www.youtube.com/iframe_api`;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    const el = document.getElementById(this.domElementId);
    const origin = el.dataset.origin;
    const opts =
      'enablejsapi=1' +
      '&controls=2' +
      '&color=white' +
      '&autohide=2' +
      '&modestbranding=1' +
      '&wmode=opaque' +
      '&showinfo=0' +
      '&rel=0' +
      `&mute=${autoplay}` +
      `&autoplay=${autoplay}` +
      `&origin=${origin}`;
    const src = `${yt}/embed/${this.id}?${opts}`;
    el.src = src;
    // console.log('{}{} src', src);
  }

  onPlayerReady(event) {
    // console.log('{}{} onPlayerReady');
  }

  onPlayerStateChange(event) {
    /**
     * -1 (unstarted)
     * 0 (ended)
     * 1 (playing)
     * 2 (paused)
     * 3 (buffering)
     * 5 (video cued).
     */
    switch (event.data) {
      case 1:
        this.trackInteraction('play');
        break;
      case 2:
        this.trackInteraction('pause');
        break;
    }
    // console.log('{}{} onPlayerStateChange', event);
  }

  onPlayerError(event) {
    console.error('YoutubePlayer.onPlayerError', event);
  }

  setupPlayer() {
    this.player = new YT.Player(this.domElementId, {
      playerVars: { autoplay: this.autoplay },
      events: {
        onReady: this.onPlayerReady.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this),
        onError: this.onPlayerError,
      },
    });
    console.log('YoutubePlayer.setupPlayer');
  }

  playVideo({ id, tracking_name = 'nvs', autoplay = false }) {
    this.id = id;
    this.tracking_name = tracking_name;
    this.autoplay = autoplay;
    if (this.player && autoplay) {
      console.log('{}{} YoutubePlayer.playVideo', id, tracking_name);
      this.player.loadVideoById(id, 0);
    } else {
      console.log('{}{} player missing');
    }
    this.trackInteraction('click');
  }

  stopVideo() {
    this.player.stopVideo && this.player.stopVideo();
  }

  trackInteraction(type) {
    triggerTracking('interaction-video', {
      englishname: 'nvs', // todo : add englishname
      videotitle: this.tracking_name,
      videocategory: 'nvs',
      featuredcontent: this.tracking_name,
      interaction: `video content ${type}`,
      interactionevent: 1,
      contentclickevent: 1,
      videoclickedevent: 1,
    });
  }
}
